import { createContext } from 'react'

export const ErrorContexts = createContext<any>(null)
